<template>
  <FormulateInput
    :name="name"
    :label="label"
    type="imageswitch"
    :options="
      cliparts.map(clipart => ({
        value: { ...clipart.file, categoryID: clipart.category.id },
        image: clipart.thumbnail.key,
        color: clipart.color,
        title: clipart.title
      }))
    "
    validation="required"
    :showTitle="true"
  />
</template>
<script>
import { get, pick, sortBy } from 'lodash'
import { fetchJsonShared } from '@/helper/helper'
export default {
  props: {
    value: {
      type: Object
    },
    categoryID: {
      type: String,
      required: true
    },
    name: {
      type: String
    },
    label: {
      type: String
    }
  },
  data() {
    return {
      selectedClipart: null,
      loading: true,
      cliparts: []
    }
  },
  mounted() {
    this.loadCliparts()
    this.selectedClipart = get(this.value, 'id')
  },
  watch: {
    categoryID() {
      this.loadCliparts()
    },
    selectedClipart(val) {
      const clipart = this.cliparts.find(cl => cl.file.id === val)
      if (clipart) {
        this.$emit('change', {
          ...pick(clipart.file, ['id', 'key']),
          categoryID: clipart.category.id
        })
      }
    }
  },
  methods: {
    loadCliparts() {
      this.loading = true
      const { categoryID } = this
      if (categoryID) {
        fetchJsonShared(`${this.$options.AWS_API_CDN}/cliparts/${categoryID}`)
          .then(cliparts => {
            for (var i = 0; i < cliparts.length; i++){
              if(cliparts[i].thumbnail == null){
                cliparts[i].thumbnail = {
                  id: cliparts[i].file.id,
                  key: cliparts[i].file.key
                }
              }
            }
            this.cliparts = sortBy(cliparts, c => c.title)
            this.loading = false
          })
          .catch(error => {
            console.log('error', error)
            this.loading = false
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Form/ClipartsByCategory.vue